import { render, staticRenderFns } from "./NewCredentialsList.vue?vue&type=template&id=5c4a43c7&scoped=true"
import script from "./NewCredentialsList.vue?vue&type=script&lang=js"
export * from "./NewCredentialsList.vue?vue&type=script&lang=js"
import style0 from "./NewCredentialsList.vue?vue&type=style&index=0&id=5c4a43c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a43c7",
  null
  
)

export default component.exports